// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AnimatedMenu{
    position: relative;
}

.AnimatedMenuItem_select{
    position: absolute;
    pointer-events: none;
    border-radius: 5px;
    transition: 500ms;
    opacity: 1;
}

.AnimatedMenuItem_select--hide{
    opacity: 0;
}

.AnimatedMenuItem_select_sizer{
    transition: 500ms;
}

.AnimatedMenuItem_items{
    display: flex;
    /*gap: 10px;*/
}

.AnimatedMenuItem{
    position: relative;
}

/*custom*/

.AnimatedMenuItem_items{
    display: flex;
    justify-content: space-between;
    background-color: #ccc;
    padding: 2px;
    background: #F3F6FF;
    border-radius: 8px;
}

.AnimatedMenuItem{
    background-color: #0000;
    width: 100%;
    min-width: fit-content;
    height: 28px;
    padding: 0px 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: calc(14px * var(--fontScaler));
} 

.AnimatedMenuItem_select{
    background-color: #fff;
    border: 0.5px solid #E2E9FC;
    box-shadow: 0px 3px 8px rgba(209, 215, 234, 0.12), 0px 3px 1px rgba(209, 215, 234, 0.04);
}`, "",{"version":3,"sources":["webpack://./src/pages/desktopPage/AnimatedMenu.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA,SAAS;;AAET;IACI,aAAa;IACb,8BAA8B;IAC9B,sBAAsB;IACtB,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,WAAW;IACX,sBAAsB;IACtB,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA;IACI,sBAAsB;IACtB,2BAA2B;IAC3B,wFAAwF;AAC5F","sourcesContent":[".AnimatedMenu{\n    position: relative;\n}\n\n.AnimatedMenuItem_select{\n    position: absolute;\n    pointer-events: none;\n    border-radius: 5px;\n    transition: 500ms;\n    opacity: 1;\n}\n\n.AnimatedMenuItem_select--hide{\n    opacity: 0;\n}\n\n.AnimatedMenuItem_select_sizer{\n    transition: 500ms;\n}\n\n.AnimatedMenuItem_items{\n    display: flex;\n    /*gap: 10px;*/\n}\n\n.AnimatedMenuItem{\n    position: relative;\n}\n\n/*custom*/\n\n.AnimatedMenuItem_items{\n    display: flex;\n    justify-content: space-between;\n    background-color: #ccc;\n    padding: 2px;\n    background: #F3F6FF;\n    border-radius: 8px;\n}\n\n.AnimatedMenuItem{\n    background-color: #0000;\n    width: 100%;\n    min-width: fit-content;\n    height: 28px;\n    padding: 0px 20px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: calc(14px * var(--fontScaler));\n} \n\n.AnimatedMenuItem_select{\n    background-color: #fff;\n    border: 0.5px solid #E2E9FC;\n    box-shadow: 0px 3px 8px rgba(209, 215, 234, 0.12), 0px 3px 1px rgba(209, 215, 234, 0.04);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
